import { render, staticRenderFns } from "./Chart3.vue?vue&type=template&id=b55a15c0&scoped=true"
import script from "./Chart3.vue?vue&type=script&lang=js"
export * from "./Chart3.vue?vue&type=script&lang=js"
import style0 from "./Chart3.vue?vue&type=style&index=0&id=b55a15c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55a15c0",
  null
  
)

export default component.exports